<template>
    <button
        class="menu-item"
        :class="{
            'is-active bg-indigo-800 text-white': isActive ? isActive() : null,
        }"
        @click="action"
        :title="title"
        type="button"
    >
        <svg class="remix">
            <use :href="`#ri-${icon}`" />
        </svg>

        <!--suppress HtmlUnknownAttribute -->
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xlink="http://www.w3.org/1999/xlink"
            width="0"
            height="0"
            style="display: none"
        >
            <symbol viewBox="0 0 24 24" id="ri-bold">
                <g>
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path
                        d="M8 11h4.5a2.5 2.5 0 1 0 0-5H8v5zm10 4.5a4.5 4.5 0 0 1-4.5 4.5H6V4h6.5a4.5 4.5 0 0 1 3.256 7.606A4.498 4.498 0 0 1 18 15.5zM8 13v5h5.5a2.5 2.5 0 1 0 0-5H8z"
                    />
                </g>
            </symbol>
            <symbol viewBox="0 0 24 24" id="ri-link">
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                    d="M17.657 14.828l-1.414-1.414L17.657 12A4 4 0 1 0 12 6.343l-1.414 1.414-1.414-1.414 1.414-1.414a6 6 0 0 1 8.485 8.485l-1.414 1.414zm-2.829 2.829l-1.414 1.414a6 6 0 1 1-8.485-8.485l1.414-1.414 1.414 1.414L6.343 12A4 4 0 1 0 12 17.657l1.414-1.414 1.414 1.414zm0-9.9l1.415 1.415-7.071 7.07-1.415-1.414 7.071-7.07z"
                />
            </symbol>
            <symbol viewBox="0 0 24 24" id="ri-unlink">
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                    d="M17.657 14.828l-1.414-1.414L17.657 12A4 4 0 1 0 12 6.343l-1.414 1.414-1.414-1.414 1.414-1.414a6 6 0 0 1 8.485 8.485l-1.414 1.414zm-2.829 2.829l-1.414 1.414a6 6 0 1 1-8.485-8.485l1.414-1.414 1.414 1.414L6.343 12A4 4 0 1 0 12 17.657l1.414-1.414 1.414 1.414zm0-9.9l1.415 1.415-7.071 7.07-1.415-1.414 7.071-7.07zM5.775 2.293l1.932-.518L8.742 5.64l-1.931.518-1.036-3.864zm9.483 16.068l1.931-.518 1.036 3.864-1.932.518-1.035-3.864zM2.293 5.775l3.864 1.036-.518 1.931-3.864-1.035.518-1.932zm16.068 9.483l3.864 1.035-.518 1.932-3.864-1.036.518-1.931z"
                />
            </symbol>
            <symbol viewBox="0 0 24 24" id="ri-italic">
                <g>
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M15 20H7v-2h2.927l2.116-12H9V4h8v2h-2.927l-2.116 12H15z" />
                </g>
            </symbol>
            <symbol viewBox="0 0 24 24" id="ri-mark-pen-line">
                <g>
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path
                        d="M15.243 4.515l-6.738 6.737-.707 2.121-1.04 1.041 2.828 2.829 1.04-1.041 2.122-.707 6.737-6.738-4.242-4.242zm6.364 3.535a1 1 0 0 1 0 1.414l-7.779 7.779-2.12.707-1.415 1.414a1 1 0 0 1-1.414 0l-4.243-4.243a1 1 0 0 1 0-1.414l1.414-1.414.707-2.121 7.779-7.779a1 1 0 0 1 1.414 0l5.657 5.657zm-6.364-.707l1.414 1.414-4.95 4.95-1.414-1.414 4.95-4.95zM4.283 16.89l2.828 2.829-1.414 1.414-4.243-1.414 2.828-2.829z"
                    />
                </g>
            </symbol>
            <symbol viewBox="0 0 24 24" id="ri-h-1">
                <g>
                    <path fill="none" d="M0 0H24V24H0z" />
                    <path d="M13 20h-2v-7H4v7H2V4h2v7h7V4h2v16zm8-12v12h-2v-9.796l-2 .536V8.67L19.5 8H21z" />
                </g>
            </symbol>
            <symbol viewBox="0 0 24 24" id="ri-h-2">
                <g>
                    <path fill="none" d="M0 0H24V24H0z" />
                    <path
                        d="M4 4v7h7V4h2v16h-2v-7H4v7H2V4h2zm14.5 4c2.071 0 3.75 1.679 3.75 3.75 0 .857-.288 1.648-.772 2.28l-.148.18L18.034 18H22v2h-7v-1.556l4.82-5.546c.268-.307.43-.709.43-1.148 0-.966-.784-1.75-1.75-1.75-.918 0-1.671.707-1.744 1.606l-.006.144h-2C14.75 9.679 16.429 8 18.5 8z"
                    />
                </g>
            </symbol>
            <symbol viewBox="0 0 24 24" id="ri-paragraph">
                <g>
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M12 6v15h-2v-5a6 6 0 1 1 0-12h10v2h-3v15h-2V6h-3zm-2 0a4 4 0 1 0 0 8V6z" />
                </g>
            </symbol>
            <symbol viewBox="0 0 24 24" id="ri-list-unordered">
                <g>
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path
                        d="M8 4h13v2H8V4zM4.5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 6.9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM8 11h13v2H8v-2zm0 7h13v2H8v-2z"
                    />
                </g>
            </symbol>
            <symbol viewBox="0 0 24 24" id="ri-list-ordered">
                <g>
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path
                        d="M8 4h13v2H8V4zM5 3v3h1v1H3V6h1V4H3V3h2zM3 14v-2.5h2V11H3v-1h3v2.5H4v.5h2v1H3zm2 5.5H3v-1h2V18H3v-1h3v4H3v-1h2v-.5zM8 11h13v2H8v-2zm0 7h13v2H8v-2z"
                    />
                </g>
            </symbol>
            <symbol viewBox="0 0 24 24" id="ri-double-quotes-l">
                <g>
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path
                        d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 0 1-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 0 1-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z"
                    />
                </g>
            </symbol>
            <symbol viewBox="0 0 24 24" id="ri-separator">
                <g>
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M2 11h2v2H2v-2zm4 0h12v2H6v-2zm14 0h2v2h-2v-2z" />
                </g>
            </symbol>
            <symbol viewBox="0 0 24 24" id="ri-text-wrap">
                <g>
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path
                        d="M15 18h1.5a2.5 2.5 0 1 0 0-5H3v-2h13.5a4.5 4.5 0 1 1 0 9H15v2l-4-3 4-3v2zM3 4h18v2H3V4zm6 14v2H3v-2h6z"
                    />
                </g>
            </symbol>
            <symbol viewBox="0 0 24 24" id="ri-format-clear">
                <g>
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path
                        d="M12.651 14.065L11.605 20H9.574l1.35-7.661-7.41-7.41L4.93 3.515 20.485 19.07l-1.414 1.414-6.42-6.42zm-.878-6.535l.27-1.53h-1.8l-2-2H20v2h-5.927L13.5 9.257 11.773 7.53z"
                    />
                </g>
            </symbol>
            <symbol viewBox="0 0 24 24" id="ri-arrow-go-back-line">
                <g>
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path
                        d="M5.828 7l2.536 2.536L6.95 10.95 2 6l4.95-4.95 1.414 1.414L5.828 5H13a8 8 0 1 1 0 16H4v-2h9a6 6 0 1 0 0-12H5.828z"
                    />
                </g>
            </symbol>
            <symbol viewBox="0 0 24 24" id="ri-arrow-go-forward-line">
                <g>
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path
                        d="M18.172 7H11a6 6 0 1 0 0 12h9v2h-9a8 8 0 1 1 0-16h7.172l-2.536-2.536L17.05 1.05 22 6l-4.95 4.95-1.414-1.414L18.172 7z"
                    />
                </g>
            </symbol>
            <symbol viewBox="0 0 24 24" id="ri-text">
                <g>
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M13 6v15h-2V6H5V4h14v2z" />
                </g>
            </symbol>
        </svg>
    </button>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            required: true,
        },

        title: {
            type: String,
            required: true,
        },

        action: {
            type: Function,
            required: true,
        },

        isActive: {
            type: Function,
            default: null,
        },
    },
};
</script>

<style scoped>
.menu-item {
    width: 1.75rem;
    height: 1.75rem;
    color: #0d0d0d;
    border: none;
    background-color: transparent;
    border-radius: 0.4rem;
    padding: 0.25rem;
    margin-right: 0.25rem;
}

.menu-item svg {
    width: 100%;
    height: 100%;
    fill: currentColor;
}

.menu-item.is-active,
.menu-item:hover {
    color: #fff;
    background-color: #0d0d0d;
}
</style>
